import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import TestResultProfilePage from 'src/pages/dashboard/test-results/profile';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/parent/dashboard'));
// EXAM RESULTS 
const StudentExaminationResultListPage = lazy(() => import('src/pages/dashboard/test-results/list'));
// PARENT FEE LIST
const ParentFeeListPage = lazy(() => import('src/pages/dashboard/fee-parent/list'));
const ParentPayFeePage = lazy(() => import('src/pages/dashboard/fee-parent/pay-fee'));
const StudentFeeCreatePage = lazy(() => import('src/pages/dashboard/fee-parent/collect'));
const HostelMessFeeCreatePage = lazy(() => import('src/pages/dashboard/student-profile/collect'));

// PARENT ATTENDANCE LIST
const ParentAttendanceListPage = lazy(() => import('src/pages/dashboard/attendance-parent/list'));
// PARENT RESULT LIST
const ParentResultListViewPage = lazy(() => import('src/pages/dashboard/result-parent/list'));
// PARENT FEE PAY PAGE
const ParentFeeDetailViewPage = lazy(() => import('src/pages/dashboard/fee-parent/collect'));
// REPORTS
const TestResultReportPage = lazy(() => import('src/pages/dashboard/reports-parent/test-result-report'));
const QuizSubjectMarksReportPage = lazy(() => import('src/pages/dashboard/reports-parent/quiz-subject-marks-report'));
const QuesWiseAnalysisReportPage = lazy(() => import('src/pages/dashboard/reports-parent/question-wise-analysis-report'));
const StudentTestAnalysisReportPage = lazy(() => import('src/pages/dashboard/reports-parent/student-test-analysis-report'));
const StudentQuesWiseAnalysisReportPage = lazy(() => import('src/pages/dashboard/reports-parent/student-question-wise-analysis-report'));
const StudentReportCardPage = lazy(() => import('src/pages/dashboard/reports-parent/student-report-card-report'));
const TaskListPage = lazy(() => import('src/pages/dashboard/task-parent/list'));
// ----------------------------------------------------------------------

export const parentdashboardRoutes = [
  {
    path: 'parentdashboard',
    element: (
      <AuthGuard>
       <RoleBasedGuard roles={['admin','academic','parent']} hasContent>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
        </RoleBasedGuard>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      {
        path: 'examinationresult',
        children: [
          { element: <StudentExaminationResultListPage />, index: true },
          { path: ':id/profile', element: <TestResultProfilePage /> },
        ],
      },
      { path: 'attendance', element: <ParentAttendanceListPage /> },
      { path: 'feeparent', element: <ParentFeeListPage /> },
      { path: 'payfee', element: <ParentPayFeePage /> },
      { path: 'testresults', element: <ParentResultListViewPage /> },
      { path: 'feepay/:id/', element: <ParentFeeDetailViewPage /> },
      {
        path: 'fee',
        children: [
          { element: <StudentFeeCreatePage />, index: true },

          { path: ':id/collect', element: <StudentFeeCreatePage /> },

        ],
      },
          {
        path: 'hostel',
        children: [
          { element: <HostelMessFeeCreatePage />, index: true },

          { path: ':id/collect', element: <HostelMessFeeCreatePage /> },

        ],
      },
         {
        path: 'mess',
        children: [
          { element: <HostelMessFeeCreatePage />, index: true },

          { path: ':id/collect', element: <HostelMessFeeCreatePage /> },

        ],
      },
      {
        path: 'testresultreport',
        children: [
          { element: <TestResultReportPage />, index: true },
          { path: 'list', element: <TestResultReportPage /> },
        ],
      },
      {
        path: 'quizsubjectmarksreport',
        children: [
          { element: <QuizSubjectMarksReportPage />, index: true },
          { path: 'list', element: <QuizSubjectMarksReportPage /> },
        ],
      },
      {
        path: 'queswiseanalysis',
        children: [
          { element: <QuesWiseAnalysisReportPage />, index: true },
          { path: 'list', element: <QuesWiseAnalysisReportPage /> },
        ],
      },
      {
        path: 'studenttestanalysis',
        children: [
          { element: <StudentTestAnalysisReportPage />, index: true },
          { path: 'list', element: <StudentTestAnalysisReportPage /> },
        ],
      },
      {
        path: 'studentqueswiseanalysis',
        children: [
          { element: <StudentQuesWiseAnalysisReportPage />, index: true },
          { path: 'list', element: <StudentQuesWiseAnalysisReportPage /> },
        ],
      },
      {
        path: 'studentreportcard',
        children: [
          { element: <StudentReportCardPage />, index: true },
          { path: 'list', element: <StudentReportCardPage /> },
        ],
      },
      {
        path: 'task',
        children: [
          { element: <TaskListPage />, index: true },
          { path: 'list', element: <TaskListPage /> },
        ],
      },
    ],
  },
];
